export const AGENT_TYPES_VALUES = {
  default: 'default',
  custom: 'custom',
} as const;

export type AgentType =
  (typeof AGENT_TYPES_VALUES)[keyof typeof AGENT_TYPES_VALUES];

export const AGENT_TYPE_LABELS: Record<AgentType, string> = {
  default: 'Default',
  custom: 'Custom',
};
